import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

import Link from 'components/Link'
import ErrorMessageContent from 'components/Errors/Messages/ErrorMessageContent'

const PGWMissingCityMessage = ({ appError }) => {
    const { i18n } = useTranslation(['errors'])
    const { vehicleId, failureTarget } = appError.data

    const basePath = `${getLocale(i18n.language)}/kayttaja/muokkaa?type=boarding_verification`
    let queryParams = ''

    if (vehicleId) {
        queryParams += `&isVerificationProcess=true&vehicleId=${vehicleId}`
    }

    if (failureTarget) {
        if (failureTarget.includes('aloita-kaupanteko') || failureTarget !== `${getLocale(i18n.language)}/kayttaja/muokkaa`) {
            queryParams += `&failurePath=${failureTarget}`
        }
    } else {
        queryParams += `&failurePath=${getLocale(i18n.language) || '/'}`
    }

    const path = `${basePath}${queryParams}`

    return (
        <ErrorMessageContent
            content={(
                <p>
                    <Trans i18nKey="errors:pgw.10127.message">
                        Your city is not set. In order to continue, please
                        <Link to={path} trackName="goToUserProfile">provide city information.</Link>
                    </Trans>
                </p>
            )}
        />
    )
}

export default PGWMissingCityMessage
